import "./ContentView.less";

import Parser from "html-react-parser";
import * as React from "react";

import { IBaseProps } from "lib/data/interfaces";

import { ContentSection } from "lib/data";


interface IContentViewProps extends IBaseProps {
	sections?: ContentSection[];
}

interface IContentViewState {

}

export class ContentView extends React.Component<IContentViewProps, IContentViewState> {

	constructor(props: IContentViewProps) {

		super(props);

		this.state = {

		};
	}

	public render() {

		// Define Class Name
		const className = "content-view" + (this.props.className ? ` ${this.props.className}` : "");

		// Check For Loaded Content
		if (this.props.sections) {

			return (

				<section className={className}>

					{this.props.sections.map((section, index) => (
						<div
							key={index}
							className="content-section"
							id={section.title.replace(/[^a-zA-Z0-9 ]/, "").replace(" ", "-")}>
							<div className="content-section-title"><span className="h4">{section.title}</span></div>
							<div className="content-section-content">{Parser(section.content)}</div>
						</div>
					))}

				</section>

			);
		}
		else {
			return undefined;
		}
	}
}
